import { DietSearchMealModel } from './diet-model';

export class FoodModel {
  constructor(
    public _id: string,
    public name: string,
    public primaryFoodUnit: string,
    public primaryFoodUnitCalorie: number,
    public foodUnitRatioArray: FoodUnitRatioModel[],
    public foodFact: FoodFacts,
    public foodFactModel: FoodFactsModel,
    public id?: string,
    public recipe?: string
  ) {}
}

export class FoodUnitRatioModel {
  constructor(public ratio: number, public unitId: FoodUnitIdModel) {}
}

export class FoodUnitIdModel {
  constructor(public name: string, public _id: string) {}
}

export class FoodFacts {
  constructor(
    public calorieAmount: number,
    public proteinAmount: number,
    public fatAmount: number,
    public carbohydrateAmount: number,
    public sugarAmount: number,
    public fiberAmount: number,
    public sodiumAmount: number,
    public potassiumAmount: number,
    public calciumAmount: number,
    public magnesiumAmount: number,
    public ironAmount: number,
    public cholesterolAmount: number,
    public phosphorAmount: number,
    public saturatedFatAmount: number,
    public polyunsaturatedFatAmount: number,
    public transFatAmount: number,
    public monounsaturatedFatAmount: number
  ) {}
}

export class FoodFactModel {
  constructor(public name: string, public amount: number) {}
}

export class FoodFactsModel {
  constructor(
    public calorie: FoodFactModel,
    public protein: FoodFactModel,
    public fat: FoodFactModel,
    public carbohydrate: FoodFactModel,
    public sugar: FoodFactModel,
    public fiber: FoodFactModel,
    public sodium: FoodFactModel,
    public potassium: FoodFactModel,
    public calcium: FoodFactModel,
    public magnesium: FoodFactModel,
    public iron: FoodFactModel,
    public cholesterol: FoodFactModel,
    public phosphor: FoodFactModel,
    public saturatedFat: FoodFactModel,
    public polyunsaturatedFat: FoodFactModel,
    public transFat: FoodFactModel,
    public monounsaturatedFat: FoodFactModel
  ) {}
}

export class RecentSearchedPackageModel {
  constructor(
    public serchedPackages: DietSearchMealModel[],
    public dietId: string,
    public meal: string
  ) {}
}

export class RecentSearchedPackagesModel {
  constructor(public recents: RecentSearchedPackageModel[]) {}

  static fromJSON(
    json: RecentSearchedPackagesModelJSON | string
  ): RecentSearchedPackagesModel {
    if (typeof json === 'string') {
      // if it's a string, parse it first
      return JSON.parse(json, RecentSearchedPackagesModel.reviver);
    } else {
      // create an instance of the User class
      const recents = Object.create(RecentSearchedPackagesModel.prototype);
      // copy all the fields from the json object
      return Object.assign(recents, json, {
        // convert fields that need converting
      });
    }
  }

  // reviver can be passed as the second parameter to JSON.parse
  // to automatically call User.fromJSON on the resulting value.
  static reviver(key: string, value: any): any {
    return key === '' ? RecentSearchedPackagesModel.fromJSON(value) : value;
  }
}

interface RecentSearchedPackagesModelJSON {
  recents: RecentSearchedPackageModel[];
}
